import React from 'react';
import { connectStateResults } from 'react-instantsearch-dom';
// import Button from '3-components/Buttons/Button';

const NoResults = props => {
    const { searchResults, clearSearchAction, noResultsHeading, noResultsSubheading, noResultsShowClearButton, noResultsClearButtonText } = props;
    if (!searchResults || searchResults.nbHits > 0) {
        return null;
    }

    return (
        <div className="hits-empty-state">
            <p className="hits-empty-state-title">{noResultsHeading}</p>
            <p className="hits-empty-state-description">{noResultsSubheading}</p>

            {noResultsShowClearButton && clearSearchAction && (
                <div className="ais-ClearRefinements">
                    <button type="button" className="ais-ClearRefinements-button" onClick={clearSearchAction}>
                        {noResultsClearButtonText}
                    </button>
                </div>
            )}
        </div>
    );
};

export default connectStateResults(NoResults);
